import {I18n} from 'react-redux-i18n';

const ruleSearchFields = (searchFieldValues, entityList) => {
    return {
        rows: [
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "name",
                        label: I18n.t("rules.search.name"),
                        type: "text",
                        value: searchFieldValues.name.value,
                    }, {
                        id: "entityId",
                        label: I18n.t("terminals.list.entity"),
                        type: "dropdown",
                        value: searchFieldValues.entityId.value,
                        data: entityList
                    },
                    {
                        id: "type",
                        label: I18n.t("rules.search.type"),
                        type: "dropdown",
                        value: searchFieldValues.type.value,
                    },
                    {
                        id: "description",
                        label: I18n.t("rules.search.description"),
                        type: "text",
                        value: searchFieldValues.description.value,
                    },
                ]
            },
        ]
    }
};

export {
    ruleSearchFields
}